export const createCalendarAPI = (request) => ({
  // Get calendar profiles (RSVPs) for the current user
  getCalendarProfiles: () => 
    request('/calendar-profiles-get', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }),
  
  // Update calendar profile (RSVP) for an event
  updateCalendarProfile: (data) => {
    console.warn('🟡 [Client] Updating calendar profile with data:', data);
    return request('/calendar-profiles-update', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  },

  // Get calendar events
  getCalendars: () => 
    request('/calendars-get', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }),
  
  // Update calendar event
  updateCalendar: (data) => {
    // Log incoming hosts data
    console.warn('🟡 [Client] Incoming hosts data:', {
      rawHosts: data.hosts,
      originalData: data
    });

    // Ensure meta data is properly structured
    const eventData = {
      ...data,
      meta: data.meta,  // Don't provide default here
      is_recurring: data.is_recurring || data.isRecurring || false,
      recurrence_pattern: data.recurrence_pattern || data.recurrencePattern || null,
      hosts: data.hosts || [],
      // Ensure consistent field names
      body_content: data.bodyContent || data.body_content,
      event_date: data.date || data.event_date,
      event_time: data.time || data.event_time,
      image_url: data.imageLink || data.image_url
    };

    console.warn('🟡 [Client] Saving calendar event with data:', {
      eventData,
      metaData: eventData.meta, // Log meta specifically
      processedHosts: eventData.hosts, // Log processed hosts
      timestamp: new Date().toISOString()
    });
    
    return request('/calendars-update', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ data: eventData })
    });
  }
}); 